import React, { useEffect, useState, useRef } from 'react'
import {
    Container,
    Row,
    Col,
    Card, 
    CardBody, 
    Modal,
    ModalHeader,
    ModalBody,
    CardHeader,
    Button,
    Table,
    Alert,
    Spinner,
} from "reactstrap";
import { connect, useDispatch } from 'react-redux';
import { fetchCoaches, fetchCoachesReset } from "redux/ScheduleTutor/ScheduleTutorActions";
import { fetchAllUsers } from "redux/ManageUsers/ManageUsersAction";
import DataTable from "react-data-table-component";
import {fetchAppHourUsedLogs, fetchAppHourUsedLogsReset} from "redux/Logs/LogsAction";
import moment from "moment-timezone";
import { customDropdown } from 'util/reactCustomStyles';
import  Select  from 'react-select';
import {monthsList, yearsList} from 'util/DataList';
import { debounce } from "lodash";

const CoachesLogHoursSummary = (props) => {

    moment.tz.setDefault("America/New_York");

    const dispatch = useDispatch();
    const [coaches, setCoaches] = useState([])
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        dispatch(fetchAppHourUsedLogsReset())
        dispatch(fetchCoachesReset())
        dispatch(fetchCoaches({getLoggedHoursDetails : true}));
        dispatch(fetchAllUsers({
            route: "",
            subscriptionFilter: "",
        }))

        dispatch(fetchAppHourUsedLogs({coachHandle : ""}))

        
    }, [])
    
    useEffect(() => {   
        
        if (props.fetchCoaches.fetchcoaches.length ) {
            
            const coachesArr = (props.fetchCoaches?.fetchcoaches?.[0] || []).sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));

            const coaches = [
                {
                    value: "",
                    label: "Select coach"
                }
            ];
      
            coachesArr.map((item) => {
                coaches.push ({
                    value : item.handle,
                    label : item.name
                })
            })

            setCoaches(coaches)
            
            
        }
        
    }, [props.fetchCoaches])


    const columns = [
        {
            name: "",
            sortable: true,
            wrap: true,
            width: "54.5px",
            cell: (row) => {
                return <i class="fas fa-eye text-info text-lg" style={{cursor:"pointer"}} onClick={(e) => showLogDetails(row)}></i>
            }
        },
        {
            name: "Primary Coach",
            sortable: true,
            wrap: true,
            width:"200px",
            selector: (row) => row.coach && row.coach.name,
            cell: (row) => {
                return row.coach && row.coach.name ? <h4 className='mb-0 text-default'>{row.coach.name}</h4> : <h3 className='mb-0'>-</h3>;
            }
        },
        {
            name: "Student",
            sortable: true,
            wrap: true,
            width:"200px",
            selector: (row) =>row.student && row.student.name ? row.student.name : "",
            cell: (row) => {
                return row.student && row.student.name ? <h4 className='mb-0 text-warning'>{row.student.name}</h4> : <h3 className='mb-0'>-</h3>;
            }
        },
        {
            id: "date",
            name: "Date",
            width: '310px',
            sortable: true,
            wrap: true,
            sortFunction: (a, b) => {
                const dateA = new Date(convertDateWithTime(a.date, a.startTime, a.endTime).split(" - ")[0]); // take start time
                const dateB = new Date(convertDateWithTime(b.date, b.startTime, b.endTime).split(" - ")[0]);
                return dateA - dateB;
            },
            cell: (row) => {
                return row.date && row.startTime && row.endTime ?  <h4 className="mb-0 text-primary">{(
                    convertDateWithTime(row.date, row.startTime, row.endTime)
                    
                )}</h4>: (
                    <h3 className='mb-0'>-</h3>
                );
            }
        },
        {
            name: "Category",
            sortable: true,
            wrap: true,
            width:"210px",
            selector: (row) => row.item && row.item.category ? row.item.category.replace("_", " ") : "",
            cell: (row) => {
                return row.item && row.item.category ? (
                  
                    <h4 className='text-uppercase mb-0 text-default'>{row.item.category.replace("_", " ")}</h4>

                ) : (
                    <h3 className='mb-0'>-</h3>
                );
            }
        },
        {
            name: "Current",
            width:"120px",
            wrap: true,
            cell: (row) => {
                return row.item && row.item.value !== undefined ? (
                    <h4 className="mb-0 text-primary">{Math.round(Number(row.item.value) * 100) / 100}</h4>
                ) : (
                    <h3 className='mb-0'>-</h3>
                );
            }
        },
        
        {
            name: "Hour",
            wrap: true,
            cell: (row) => {
                if (row.item && row.item.category && row.item.value !== undefined && row.item.prev !== undefined) {
                    return row.item.category === "premium_hour" ? (
                        <h4 className="text-danger mb-0" onClick={(e) => showLogDetails(row)}>
                            -{Number(row.item.prev) - Number(row.item.value)}
                        </h4>
                    ) : (
                        <h4 className="text-success mb-0" onClick={(e) => showLogDetails(row)}>
                            +{Number(row.item.value) - Number(row.item.prev)}
                        </h4>
                    );
                }
                return <h3 className='mb-0'>-</h3>
            }
        },
        {
            name: "Comment",
            width: "120px",
            wrap: true,
            cell: (row) => {
                return row && row.comment ? <h4 className="mb-0 text-default text-truncate">{row.comment}</h4> : "N/A";
            }
        },
        
        // {
        //     name: "Action",
        //     width: '200px',
        //     cell: (row) => (
        //         <>
        //             <EditAppLog item={row} />
        //             <DeleteAppLog />
        //         </>
        //     ),
        //     center: true,
        //     wrap: true
        // },
    ];

    const tableHeaderstyle = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px",
                // backgroundColor: "#ccc",
                
            },
        },
    };

    const [nestedModal, setNestedModal] = useState(false);
    const [closeAll, setCloseAll] = useState(false);

    const toggleNested = () => {
        setNestedModal(!nestedModal);
        setCloseAll(false);
    };

    const showLogDetails = (data) =>{
        
        setSelectUserLogDetails(data)
        setNestedModal(!nestedModal);
        
    }

    const convertDateWithTime = (date, itemFrom,itemTo) => {
        
        let localdate = convertDate(date)
        let start = convertTimeToLocal(itemFrom).format("h:mm A")
        let end = convertTimeToLocal(itemTo).format("h:mm A")
        return localdate + ", "+start+" - "+end
    }

    const convertTimeToLocal = (time) => {
        return moment(moment(time).utcOffset(0, true), "HH:mm")
    }


    

    const [logsData, setLogsData] = useState([]);
    useEffect(() => {

        

        if (props.fetchAppHourUsedLogs.loading) {
            setLoading(true)
        } else {
            if (props.fetchAppHourUsedLogs.logs.length) {
                setLogsData(props.fetchAppHourUsedLogs.logs)
            }else{
                setLogsData([]) 
            }	
            setLoading(false)
            
        }
    }, [props.fetchAppHourUsedLogs]);

    const convertDate = (date) => {
        return moment(date).utcOffset(0, true).format('LL');
    }

    const [selectUserLogDetails, setSelectUserLogDetails] = useState()


    const generateYearOptions = (startYear = 2020) => {
        const currentYear = new Date().getFullYear();
        const years = [];

        for (let year = currentYear; year >= startYear; year--) {
            years.push({
            label: year.toString(),
            value: year
            });
        }

        return years;
    }

    const yearsLists = generateYearOptions()

    const [year, setYear] = useState("")
    const [month, setMonth] = useState("")
    const [coachHandle, setCoachHandle] = useState("")

    const debouncedSearchCoachesLogHours = useRef(
        debounce((year, month, coachHandle) => {
            
            dispatch(fetchAppHourUsedLogs({coachHandle , month , year}))
            setLoading(true)
        }, 2000)
    );

    useEffect(() => {
        debouncedSearchCoachesLogHours.current(year,month,coachHandle)
    }, [year, month, coachHandle])
    

    



    return (
        <Card className="shadow mb-3">
            <CardHeader className="border-1">
            <Row className="align-items-center">
                <div className="col">
                    <h3 className="mb-0 text-default">Coaches Log Hours Summary</h3>
                </div>
                <div className="col text-right">
                {/* <Button
                    color="primary"
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                    size="sm"
                >
                    See all
                </Button> */}
                </div>
            </Row>
            </CardHeader>
            
            <CardBody>
                <Row className='mb-1'>
                    <Col className='md-4'>
                        <Select 
                            placeholder='Select Month'
                            options={monthsList} 
                            styles={customDropdown }  
                            onChange={(e) => setMonth(e.value)}
                            menuPortalTarget={document.body}
                            id="monthFilter"
                            // defaultValue={lessonTypeOptions.find((option) => option.value == lessonType)}
                        />
                    </Col>
                    <Col className='md-4'>
                        <Select 
                            placeholder='Select Year'
                            options={yearsLists} 
                            styles={customDropdown }  
                            onChange={(e) => setYear(e.value)}
                            menuPortalTarget={document.body}
                            id="yearFilter"
                            // defaultValue={lessonTypeOptions.find((option) => option.value == lessonType)}
                        />
                    </Col>
                    <Col className='md-4'>
                        <Select 
                            placeholder='Select Coach'
                            options={coaches} 
                            styles={customDropdown }  
                            onChange={(e) => setCoachHandle(e.value)}
                            menuPortalTarget={document.body}
                            id="coachHandleFilter"
                            // defaultValue={lessonTypeOptions.find((option) => option.value == lessonType)}
                        />
                    </Col>
                </Row>
                    { 
											
                        loading ? 
                            <div className="m-5">
                                <Alert color="secondary" className="text-center">
                                    Collecting data.. Please wait while loading {" "}
                                    <Spinner size="sm" color="primary" />{" "}
                                </Alert>
                            </div>
                        : logsData.length ? 
                                <DataTable
                                    progressPending={loading}
                                    paginationRowsPerPageOptions={[5,10,30,50,100]}
                                    customStyles={tableHeaderstyle}
                                    columns={columns}
                                    data={logsData}
                                    pagination
                                    wrap
                                    defaultSortFieldId="date"  
                                    defaultSortAsc={false} 
                                    // selectableRows
                                    // fixedHeader
                                    selectableRowsHighlight
                                    highlightOnHover
                                    // subHeader
                                    // subHeaderComponent={
                                    // <input
                                    //     type="text"
                                    //     className="w-50 form-control"
                                    //     placeholder="Search..."
                                    //     value={search}
                                    //     onChange={(e) => setSearch(e.target.value)}
                                    // />
                                    // }
                                    // subHeaderAlign="right"
                                />
                        : 
                       
                        <div className="m-5">
                             <Alert color="primary">No data available .</Alert>
                        </div>
                    
                    }
            </CardBody>
        
        <Modal
            isOpen={nestedModal}
            toggle={toggleNested}
            
            // size="xl"
            centered
        >
            <ModalHeader toggle={toggleNested}>
            {selectUserLogDetails ? "Docid: " + selectUserLogDetails.docid: ""}
            </ModalHeader>
            <ModalBody className="pt-1">
                
                    {
                        selectUserLogDetails ? 
                        <>
                        <p><b>Category: </b > {<span className=" mb-0">{selectUserLogDetails.item.category.replace("_"," ")}</span> }</p>
                        <p><b>Date: </b > {<span className=" mb-0">{convertDateWithTime(selectUserLogDetails.date, selectUserLogDetails.startTime,  selectUserLogDetails.endTime)}</span> }</p>
                        <p><b>Value: </b > 
                        {  selectUserLogDetails.item.category == "premium_hour"  ? 
                        
                            <span className="text-danger"> -{Number(selectUserLogDetails.item.prev) - Number(selectUserLogDetails.item.value) }</span>  
                                : 
                            <span className="text-primary"> +{Number(selectUserLogDetails.item.value) - Number(selectUserLogDetails.item.prev) }</span>   
                        }
                        </p>
                        <p><b>Coach: </b > <span className=" mb-0">{selectUserLogDetails.coach.name}</span> </p>
                        <p><b>Student: </b > <span className=" mb-0">{selectUserLogDetails.student.name}</span> </p>
                        <p><b>Comment: </b > {selectUserLogDetails.comment} </p>
                        
                        </>
                        : ""

                    }
                
                
            </ModalBody>
            
        </Modal>

            
        </Card>
    )
}

const mapStateToProps = (state) => {
    return {
      fetchAllUsers: state.fetchAllUsers,
      fetchCoaches: state.fetchCoaches,
      fetchAppHourUsedLogs: state.fetchAppHourUsedLogs,
    };
};
  
export default connect(mapStateToProps)(CoachesLogHoursSummary);